import { SSharedList } from '@/services'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        organizations: false
      },
      options: {
        organizations: []
      },
      selected: {
        organization: null
      },
      editable: {
        organization: null
      }
    }
  },

  methods: {

    async getOrganizations (context, search = '') {
      const selectedContext = Object.hasOwnProperty.call(context, 'selected')
      const fetchingContext = Object.hasOwnProperty.call(context, 'fetching')
      const optionsContext = Object.hasOwnProperty.call(context, 'options')

      if (!selectedContext || !fetchingContext || !optionsContext) {
        throw Error('Invalid context object')
      }

      const selected = Object.hasOwnProperty.call(context.selected, 'organization')
      const fetching = Object.hasOwnProperty.call(context.fetching, 'organizations')
      const options = Object.hasOwnProperty.call(context.options, 'organizations')

      if (!selected || !fetching || !options) {
        throw Error('Invalid context object')
      }

      context.fetching.organizations = true
      context.selected.organization = null

      const filters = {
        filter_text: search
      }

      return await SSharedList.getOrganizations(filters).then(
        ({ data }) => {
          context.options.organizations = data
        }
      ).catch(() => {
        context.options.organizations = []
      }).finally(() => {
        context.fetching.organizations = false
      })
    },

    async searchOrganizations (search, loading) {
      if (search.length >= 3) {
        this.searchOrganizationsProvider(this, search, loading)
      }
    },

    searchOrganizationsProvider: QUERY.debounce(
      ({ options, fuseFilter }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.organizations, {
          keys: ['organization_name']
        })

        if (filteredOptions.length <= 2) {
          loading(true)

          const filters = {
            filter_text: search
          }

          SSharedList.getOrganizations(filters).then(
            ({ data }) => {
              options.organizations = data
            }
          ).catch(() => {
            options.organizations = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
